module.exports = __webpack_public_path__ + "static/media/testimonial-1.2eb96321.jpg";